import { createContext, useContext } from 'react';

import { RegionManager } from './RegionManager';

export const RegionContext = createContext<{ regionManager?: RegionManager }>({ regionManager: null });

export const useRegionContext = () => useContext(RegionContext);
